import _ from 'lodash';
import { createSelector } from 'reselect';

export const getUpdatePassword = state => _.get(state, 'cvPasswordModify');

export const getPayload = createSelector(
  [getUpdatePassword],
  updatePassword => _.get(updatePassword, 'payload', false),
);

export const getLoading = createSelector(
  [getUpdatePassword],
  updatePassword => _.get(updatePassword, 'loading', false),
);

export const getError = createSelector(
  [getUpdatePassword],
  updatePassword => _.get(updatePassword, 'error', false),
);

export const getUpdatePasswordError = createSelector(
  [getError],
  error => {
    if (error)
      return {
        code: _.get(error, 'code', false),
        message: _.get(error, 'error', false),
      };
    return error;
  },
);

export const getUpdatePasswordSuccess = createSelector(
  [getPayload],
  payload => {
    const code = _.get(payload, 'code', false);
    const message = _.get(payload, 'msg', false);
    if (code)
      return {
        code,
        message,
      };
    return false;
  },
);
